import { Feature } from '../../../constants/Feature';

export const createOnboardingFeatureStoreKey = (feature: Feature): string => `Onboarding.${feature}`;
